import { getWindow } from './get-window.js';

export function getDocumentBody(node?: unknown) {
  return getWindow(node).document.body;
}
